// "← Back to Orders" target (2026-09-16, Eric): the remembered list URL is only
// reused when it belongs to the store the sidebar is on. Its ?loc= is replaced
// by the sidebar's current location (or loc=all when "All Locations"), so a
// store / location change made while reading an order carries into the list
// instead of dragging the user back to the store and location they came from.
export function resolveOrdersBackTo(cached, activeStore, emulating) {
    const store = activeStore || 'soccerpost';
    const emuLoc = emulating?.shopify_location_id ? String(emulating.shopify_location_id) : '';
    const fallback = `/store/${store}/orders${emuLoc ? `?loc=${emuLoc}` : ''}`;
    if (!cached) return fallback;
    try {
        const u = new URL(cached, window.location.origin);
        const m = u.pathname.match(/^\/store\/([^/]+)\/orders\/?$/);
        if (!m || m[1] !== store) return fallback;          // different store → clean list for this store
        const loc = u.searchParams.get('loc');
        const cachedLoc = (!loc || loc === 'all') ? '' : loc;
        if (cachedLoc !== emuLoc) {                          // keep the filters, fix the location
            u.searchParams.set('loc', emuLoc || 'all');
        }
        return u.pathname + u.search;
    } catch {
        return fallback;
    }
}

// "← Back to Orders (Soccer Post · Teams Lancaster)" — names the store and
// location the list will open at (Eric 2026-09-16). All Locations when no
// sidebar location is selected.
export function ordersBackToLabel(activeStore, emulating, storeNames) {
    const store = (storeNames && storeNames[activeStore]) || activeStore || 'Soccer Post';
    const loc = emulating?.name || 'All Locations';
    return `← Back to Orders (${store} · ${loc})`;
}
